var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMindalayLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_552_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7962 0H2.20383C0.986687 0 0 0.986687 0 2.20383V37.7962C0 39.0133 0.986687 40 2.20383 40H37.7962C39.0133 40 40 39.0133 40 37.7962V2.20383C40 0.986687 39.0133 0 37.7962 0Z",
    fill: "#E56B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3123 9.83545V30.1332C29.6988 30.1332 28.3903 28.8247 28.3903 27.2112V17.4599L22.2486 27.4501C21.211 29.1376 18.7588 29.1376 17.7212 27.4501L11.5004 17.3321V27.2119C11.5004 28.8254 10.1926 30.1332 8.5791 30.1332V9.83545H8.6568C9.69082 9.83545 10.6515 10.3721 11.1932 11.2536L19.9845 25.5527L28.7766 11.2529C29.3183 10.3721 30.2783 9.83545 31.3123 9.83545Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_552_818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindalayLogo);
export default __webpack_public_path__ + "static/media/mindalay-logo.30a6ea1edb02f0aa77b2ab16a9da8954.svg";
export { ForwardRef as ReactComponent };